import { render, staticRenderFns } from "./sl-vue-tree.vue?vue&type=template&id=56f4c689&"
import script from "./sl-vue-tree.js?vue&type=script&lang=js&"
export * from "./sl-vue-tree.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports